import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { EmbedNodeView } from "@/components/editor/nodeviews/EmbedNodeView";

export const EmbedBlock = Node.create({
  name: "embedBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      engine: { default: "latex" },
      code: { default: "" },
      caption: { default: "" },
      label: { default: "" },
      previewImage: { default: "" },
      packages: { default: [] },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="embed-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "embed-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(EmbedNodeView);
  },
});
